import _regeneratorRuntime from "@babel/runtime/regenerator";
import { put } from 'redux-saga/effects';
import { dropReadModelResult } from './actions';
import { CONNECT_READMODEL } from '../internal/action-types';

var disconnectReadModelSaga = /*#__PURE__*/_regeneratorRuntime.mark(function disconnectReadModelSaga(sagaArgs, action) {
  var sagaManager, sagaKey, query;
  return _regeneratorRuntime.wrap(function disconnectReadModelSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          sagaManager = sagaArgs.sagaManager, sagaKey = sagaArgs.sagaKey;
          query = action.query;
          return _context.delegateYield(sagaManager.stop("" + CONNECT_READMODEL + sagaKey), "t0", 3);

        case 3:
          _context.next = 5;
          return put(dropReadModelResult(query));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, disconnectReadModelSaga);
});

export default disconnectReadModelSaga;
//# sourceMappingURL=disconnect-read-model-saga.js.map